export const DATE_FORMATS = {
  COMMENT: 'ddd MM/DD h:mm a',
  STANDARD: 'YYYY-MM-DD',
  MEDIUM: 'MMM D, YYYY',
  DAY: 'ddd MM/DD',
  SHORT: 'MM/DD/YYYY',
  ACTIVE: 'M/DD [at] h:mm a',
  CUSTOM: 'HH:mm - MMMM D YYYY'
};
